import React from 'react';
import PropTypes from 'prop-types';

const ContactFormDisclaimer = ({ buttonText }) => (
  <div className="submit-disclaimer">
    <p>
      Yes, I would like more information from Sotheby's International Realty, Inc. Please use and/or share my information with a 
      Sotheby's International Realty, Inc. agent to contact me about my real estate needs.
    </p>
    <p>
      By clicking {buttonText}, I agree a Sotheby's International Realty, Inc. 
      agent may contact me by phone or text message including by automated means about real estate services, and that I can 
      access real estate services without providing my phone number. I acknowledge that I have read and agree to the 
      <a href="https://www.sothebysrealty.com/eng/terms" target="_blank">Terms of Use</a> and <a href="https://www.sothebysrealty.com/eng/privacy-policy" target="_blank">Privacy Policy</a>.
    </p>
  </div>
);

ContactFormDisclaimer.propTypes = {
  buttonText: PropTypes.string.isRequired
};

export default ContactFormDisclaimer;


// WEBPACK FOOTER //
// ./src/components/contact/contact-form-disclaimer.js